const PlaceholderValue = ({ placeholder, isPresent = true, children }) => (
    <>
        {children && isPresent ? (
            children
        ) : (
            <span className='text-gray-400'>{placeholder}</span>
        )}
    </>
);

export default PlaceholderValue;
